import React from 'react';
import '../assets/css/Header.css';

function Header(props) {
  return (
    <div className="header">
      <div className="logo">
        {Logo(props.isLogoImg, props.title, props.img)}
      </div>
      <div className="navigation">
        <a className="nav-link active" href="https://hikimo.github.io">Profile</a>
        <a className="nav-link" href="https://hikimo.github.io">Gallery</a>
        <a className="nav-link" href="https://hikimo.github.io">Contact</a>
      </div>
      <div className="navbar-right">
        <button className="btn btn-light">
          <span className="btn-text"><i className="fa fa-download mr-1"></i>Resume</span>
        </button>
      </div>
    </div>
  );
}

const Logo = (isLogoImg = false, title = null, img = null) => {
  if(isLogoImg) {
    return  <img src={img} alt={title} className="logo-img" />
  }

  return <h1 className="title">{title}</h1>
}

export default Header;
